<div class="relative w-full h-{{height}} overflow-hidden perspective-[1000px]">
  <div
    *ngFor="let image of images; let i = index"
    class="absolute w-full h-full transition-all duration-1000 ease-in-out bg-cover bg-center rounded-xl"
    [ngClass]="{
      'rotate-y-0 z-20 opacity-100': currentIndex === i,
      '-rotate-y-180 z-10 opacity-0': currentIndex !== i
    }"
    [style.backgroundImage]="'url(' +fileUrl + image + ')'"
  ></div>
</div>
